import {
  formatPackagePrice,
  type PaymentPackage,
} from '@/hooks/api/usePayments';
import { t } from '@/i18n';
import styles from './TariffGrid.module.css';

interface TariffGridProps {
  packages: PaymentPackage[];
  onSelect?: (pkg: PaymentPackage) => void;
  hideTitle?: boolean;
  value?: string | null;
}

export function TariffGrid({
  packages,
  onSelect,
  hideTitle,
  value,
}: TariffGridProps) {
  const readingPackages = packages.filter((p) => p.type === 'READINGS');

  return (
    <div className={hideTitle ? styles.embedded : undefined}>
      {hideTitle ? null : (
        <div className={styles.ttl}>{t.profile.buySpreads}</div>
      )}
      <div className={styles.grid}>
        {readingPackages.map((pkg) => (
          <button
            key={pkg.id}
            type="button"
            className={[styles.tile, value === pkg.id ? styles.selected : '']
              .filter(Boolean)
              .join(' ')}
            onClick={() => onSelect?.(pkg)}
          >
            {pkg.best ? (
              <span className={styles.bestb}>{t.profile.bestDeal}</span>
            ) : null}
            <div className={styles.tcnt}>{pkg.label}</div>
            <div className={styles.tprc}>
              {formatPackagePrice(pkg.amount, pkg.currency)}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
